import { ContactSection } from "~/components/marketing/contact-section";
import { generateMetaTags, SITE_URL } from "~/lib/seo";

export function meta() {
	return generateMetaTags({
		title: "Kontakt – FirmIndex",
		description: "Máte dotaz nebo potřebujete pomoci? Napište nám a ozveme se vám co nejdříve.",
		canonical: `${SITE_URL}/kontakt`,
	});
}

export default function Kontakt() {
	return (
		<>
			{/* Header */}
			<section className="public-hero mx-3 mt-3 rounded-3xl px-6 pb-12 pt-16 sm:mx-4 lg:px-8 lg:pt-24">
				<div className="mx-auto max-w-4xl text-center">
					<h1 className="text-4xl font-extrabold tracking-tight text-text sm:text-5xl">Kontakt</h1>
					<p className="mx-auto mt-4 max-w-2xl text-lg text-muted">
						Máte dotaz nebo potřebujete pomoci? Napište nám a ozveme se vám co nejdříve.
					</p>
				</div>
			</section>

			<ContactSection />
		</>
	);
}
